module.exports = __webpack_public_path__ + "static/roninDji-2402a577f1c791008d945107b2a556e5.png";